<div class="dialog-container">
  <app-mat-spinner-overlay [overlay]="true" *ngIf="loading">
  </app-mat-spinner-overlay>

  <div class="dialog-header">
    <h2 mat-dialog-title>
      Editar Acordo{{ acordosSelecionados.length > 1 ? "s" : "" }}
    </h2>
    <button
      mat-icon-button
      [mat-dialog-close]="null"
      class="close-button"
      matTooltip="Fechar diálogo"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- {{acordosSelecionados | json}} -->
  <app-acordos-existentes
    style="padding: 16px"
    *ngIf="acordosExistentes.length"
    [combustiveis]="combustiveis"
    [acordosExistentes]="acordosExistentes"
    [msgAcordosExistentes]="msgAcordosExistentes"
  >
  </app-acordos-existentes>

  <div class="dialog-content">
    <div class="info-text">
      <mat-icon color="warn">warning</mat-icon>
      <span>Clique em uma linha para ativar a edição dos campos.</span>
    </div>
    <div class="info-text" *ngIf="precosComErro">
      <mat-icon>info</mat-icon>
      <span
        >
        {{msgErroPrecos}}
        </span
      >
    </div>

    <div class="acordos-grid">
      <div class="grid-header">
        <div>Acordo</div>
        <div>Frota</div>
        <div>Combustível</div>
        <div>Preço Bomba</div>
        <div>Desc / Acresc</div>
        <div>Preço Acordo</div>
        <div>Período</div>
        <div>Prazo</div>
        <div>Taxa</div>
      </div>

      <div
        class="grid-row"
        *ngFor="let acordo of acordosSelecionados"
        [class.selected]="acordo === acordoSelecionado"
        (click)="selecionarAcordo(acordo)"
      >
        <div>{{ acordo.codAcordo }}</div>
        <div>{{ acordo.razaoSocialFrota }}</div>
        <div>{{ acordo.tipoCombustivel }}</div>
        <div>{{ acordo.vlrPrecoTela | currency }}</div>

        <div
          class="campo-editavel"
          *ngIf="
            acordo === acordoSelecionado && !acordoPrecoFixo;
            else valorDesconto
          "
        >
          <mat-form-field>
            <input
              #descontoInput
              matInput
              type="text"
              autocomplete="off"
              [(ngModel)]="acordo.vlrDescontoFixoAcordo"
              (keyup)="alterandoValorDesconto(acordo)"
              currencyMask
              forceCursorEnd
              [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
              (click)="$event.stopPropagation()"
            />
          </mat-form-field>
        </div>
        <ng-template #valorDesconto>
          <div>{{ acordo.vlrDescontoFixoAcordo | currency }}</div>
        </ng-template>

        <div
          class="campo-editavel"
          *ngIf="
            acordo === acordoSelecionado && acordoPrecoFixo;
            else valorPrecoFixo
          "
        >
          <mat-form-field>
            <input
              #precoInput
              matInput
              type="text"
              autocomplete="off"
              [(ngModel)]="acordo.vlrPrecoAcordo"
              currencyMask
              forceCursorEnd
              (keyup)="alterandoValorDesconto(acordo)"
              [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
              placeholder="R$ 0,00"
              (click)="$event.stopPropagation()"
            />
          </mat-form-field>
        </div>
        <ng-template #valorPrecoFixo>
          <div>{{ acordo.vlrPrecoAcordo | currency }}</div>
        </ng-template>

        <div>{{ acordo.dscPeriodo }}</div>
        <div>{{ acordo.numPrazo }}</div>
        <div>
          {{ acordo.vlrMdr ? (acordo.vlrMdr / 100 | percent: "1.2-2") : "" }}
        </div>
      </div>
    </div>

    <mat-dialog-actions align="end">
      <button mat-button class="btn-acao" (click)="onNoClick()">
        Cancelar
      </button>
      <button
        mat-flat-button
        class="btn-acao"
        [ngClass]="
          houveMudancasNosAcordosSelecionados() && !precosComErro
            ? 'btn-confirmar'
            : ''
        "
        [disabled]="!houveMudancasNosAcordosSelecionados() || precosComErro"
        (click)="onConfirm()"
      >
        Confirmar
      </button>
    </mat-dialog-actions>
  </div>
</div>
